import { useEntitlements } from "@/hooks/useEntitlements";

export function useFiscalEnabled(): boolean {
  const { data } = useEntitlements();
  return data?.activeModules.includes("fiscal") ?? false;
}
